<app-header class="full-width"></app-header>
<main id="content" class="js-content" role="main">
  <div class="grid-row">
    <div class="column-full">
      <header class="page-header">
        <h1 class="aa-title-size" tabindex="0">Multiplication tables check questions</h1>
      </header>
      <p class="lede aa-copy-size" tabindex="0">
        There will be {{count}} questions.
      </p>
      <div>
        <button type="button" class="button button-start aa-button-size aa-contrast-button" id="start-now-button" (click)="onClick()">
          Start now
          <app-svg-arrow aria-hidden="true"></app-svg-arrow>
        </button>
      </div>
    </div>
  </div>
</main>
